import {
    getLocale,
    setLocale as setParaglideLocale,
    toLocale,
    type Locale
} from '$lib/paraglide/runtime.js'

export const FamilyLocaleDisplayNames: Record<Locale, string> = {
    en: 'English',
    es: 'Español',
    ar: 'العربية'
}

export type AppLanguage = 'en' | 'es'

export function toAppLanguage(value: unknown): AppLanguage {
    return value === 'es' ? 'es' : 'en'
}

export class FamilyLocaleService {
    public current = $state<Locale>(getLocale())
    public accountRevision = $state(0)

    public setFromInput(value: unknown): Locale | undefined {
        const nextLocale = toLocale(value)

        if (!nextLocale) {
            return undefined
        }

        this.current = nextLocale
        void setParaglideLocale(nextLocale, { reload: false })

        return nextLocale
    }

    public setFromAccountPreference(value: unknown): AppLanguage {
        const appLanguage = toAppLanguage(value)

        if (appLanguage === this.current) {
            return appLanguage
        }

        this.current = appLanguage
        void setParaglideLocale(appLanguage, { reload: false })
        this.accountRevision += 1
        return appLanguage
    }
}
